/* ════ RESOURCE MODAL ══════════════════════════════════════ */
import { state } from '../state.js';
import { $ } from '../dom.js';
import { RES_COLS, ROLE_SUGGESTIONS } from '../config.js';
import { sb } from '../supabase/client.js';
import { setSyncDot } from '../supabase/data.js';
import { showToast } from '../utils/toast.js';
import { createAuthUser } from '../auth.js';

export function closeResModal() { $('res-modal').classList.remove('open'); }

// Datalist suggestions: built-in roles plus any the team already uses.
function refreshRoleList() {
  const dl = $('role-list'); if (!dl) return;
  const used = state.resources.map(r => r.role).filter(Boolean);
  const roles = [...new Set([...ROLE_SUGGESTIONS, ...used])].sort();
  dl.innerHTML = roles.map(r => `<option value="${r}"></option>`).join('');
}

export function renderResList() {
  refreshRoleList();
  $('res-list').innerHTML = state.resources.map((r, i) => `
    <div class="res-item">
      <div class="res-row">
        <div style="width:11px;height:11px;border-radius:50%;background:${r.col};flex-shrink:0"></div>
        <span style="flex:1;font-size:13px;font-weight:600;color:var(--ink)">${r.name}</span>
        ${i > 0 ? `<button onclick="deleteResource('${r.id}')" style="padding:3px 10px;border-radius:6px;border:1.5px solid var(--ooo-bd);color:var(--ooo);background:none;font-size:11px;font-weight:700" onmouseover="this.style.background='var(--ooo-bg)'" onmouseout="this.style.background='none'">Remove</button>` : ''}
      </div>
      <input class="res-role" type="text" list="role-list" placeholder="role (e.g. Consultant) — filterable on the planner" value="${r.role || ''}" onchange="setResRole('${r.id}', this.value)">
      <input class="res-email" type="email" placeholder="login email — links this person for inbox & assignment alerts" value="${r.user_email || ''}" onchange="setResEmail('${r.id}', this.value)">
      ${bdayPicker(r)}
    </div>`).join('');
}

// Birthday: day + month only (no year, no age). Stored as 'MM-DD'.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function bdayPicker(r) {
  const [m, d] = (r.birthday || '-').split('-');
  const days = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));
  return `<div class="res-bday"><span>🎂 Birthday</span>
    <select class="bd-d" onchange="setResBirthday('${r.id}', this.parentNode)" aria-label="Birthday day"><option value="">Day</option>${days.map(x => `<option value="${x}"${x === d ? ' selected' : ''}>${Number(x)}</option>`).join('')}</select>
    <select class="bd-m" onchange="setResBirthday('${r.id}', this.parentNode)" aria-label="Birthday month"><option value="">Month</option>${MONTHS.map((x, i) => { const v = String(i + 1).padStart(2, '0'); return `<option value="${v}"${v === m ? ' selected' : ''}>${x}</option>`; }).join('')}</select>
    <span class="res-bday-note">confetti for them on the day</span></div>`;
}

export async function setResBirthday(id, box) {
  const d = box.querySelector('.bd-d').value, m = box.querySelector('.bd-m').value;
  if (!!d !== !!m) return;   // wait until both are picked (or both cleared)
  const birthday = d && m ? `${m}-${d}` : null;
  if (birthday && new Date(2024, Number(m) - 1, Number(d)).getDate() !== Number(d)) { showToast('That date doesn’t exist'); return; }
  setSyncDot('busy');
  const { error } = await sb.from('resources').update({ birthday }).eq('id', id);
  if (error) {
    setSyncDot('err');
    showToast(/birthday/.test(error.message) ? 'Birthdays need migration 0026 first' : 'Failed: ' + error.message);
    return;
  }
  const r = state.resources.find(x => x.id === id); if (r) r.birthday = birthday;
  setSyncDot('ok'); showToast(birthday ? `🎂 Saved: ${Number(d)} ${MONTHS[Number(m) - 1]}` : 'Birthday cleared');
}

export async function setResRole(id, role) {
  setSyncDot('busy');
  const { error } = await sb.from('resources').update({ role: role.trim() || null }).eq('id', id);
  if (error) { setSyncDot('err'); showToast('Failed: ' + error.message); } else { setSyncDot('ok'); showToast('Saved ✓'); }
}

export async function setResEmail(id, email) {
  setSyncDot('busy');
  const { error } = await sb.from('resources').update({ user_email: email.trim() || null }).eq('id', id);
  if (error) { setSyncDot('err'); showToast('Failed: ' + error.message); } else { setSyncDot('ok'); showToast('Saved ✓'); }
}

export async function addResource() {
  const name = $('new-res').value.trim(); if (!name) { showToast('Enter a name'); return; }
  const email = $('new-res-email').value.trim(), pass = $('new-res-pass').value;
  const role = $('new-res-role').value.trim();
  const id = name.toLowerCase().replace(/\s+/g, '-') + '-' + Date.now();
  const col = RES_COLS[state.resources.length % RES_COLS.length];
  const ini = name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
  setSyncDot('busy');
  const { error } = await sb.from('resources').insert({ id, name, ini, col, sort: state.resources.length, role: role || null, user_email: email || null });
  if (error) { setSyncDot('err'); showToast('Failed: ' + error.message); return; }
  setSyncDot('ok');
  // Optionally create their login in the same step.
  if (email && pass) {
    if (pass.length < 6) showToast('Resource added — password too short to create a login');
    else { const { error: aerr } = await createAuthUser(email, pass); showToast(aerr ? 'Resource added; login failed: ' + aerr.message : 'Resource + login added ✓'); }
  } else showToast('Resource added ✓');
  $('new-res').value = ''; $('new-res-role').value = ''; $('new-res-email').value = ''; $('new-res-pass').value = '';
}

export async function deleteResource(id) {
  if (!confirm('Remove resource?')) return; setSyncDot('busy');
  const { error } = await sb.from('resources').delete().eq('id', id);
  if (error) { setSyncDot('err'); showToast('Failed: ' + error.message); }
  else { setSyncDot('ok'); showToast('Resource removed'); renderResList(); }
}

export function initResourceModal() {
  $('btn-res').addEventListener('click', () => { renderResList(); $('res-modal').classList.add('open'); });
}
